import { TextSection } from "@/components/custom";
import { featuresdata } from "../../../config/landingPageConfig.tsx";

export const Features = () => {
  return (
    <div className="lg:px-10 px-5 py-20 items-center justify-center flex-col flex">
      <TextSection
        heading="Features"
        subtext="No matter what project you're working on, we've got you covered with the best wireframe kits for any platform."
        className="mx-auto max-w-xl"
      />
      <div className="bg-[#141414] border-[#262626] mt-20 border rounded-xl  p-5 lg:p-10 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
        {featuresdata.map((feature) => (
          <div className="bg-[#1A1A1A] border border-[#262626] mx-auto flex flex-col space-y-5 justify-center h-[157px] rounded-xl p-5 lg:p-10">
            <h2 className="lg:text-[22px] text-lg md:text-xl text-white font-semibold">
              {feature.title}
            </h2>
            <h1 className="text-[#FFFFFF99] lg:text-[18h1x] text-sm">
              {feature.text}
            </h1>
          </div>
        ))}
      </div>
    </div>
  );
};
